// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.W5tuG .Lmhqv{margin-top:1.75rem}.W5tuG .ui.form .field.disabled>.input,.W5tuG .ui.form .field.disabled>label,.W5tuG .ui.form .field.disabled>textarea{opacity:1!important}.W5tuG .C2bPh{border:none!important;cursor:pointer;overflow:hidden;padding:.1rem 1.5rem .1rem 0!important;text-overflow:ellipsis}.W5tuG .zAjAb{border-color:#db2828!important}.W5tuG .zAjAb:before{box-shadow:0 -1px 1px 0 #db2828!important}.W5tuG .KjaeT{box-shadow:none!important}.W5tuG .Vrezn{font-style:italic;margin-top:1rem}.W5tuG .od1Tv{margin-top:2rem;width:100%}.W5tuG .od1Tv code{overflow-wrap:break-word!important;white-space:pre-wrap!important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalContent": `W5tuG`,
	"divider": `Lmhqv`,
	"dateInput": `C2bPh`,
	"errorPopup": `zAjAb`,
	"noBoxShadow": `KjaeT`,
	"keyValueMessage": `Vrezn`,
	"keyValue": `od1Tv`
};
module.exports = ___CSS_LOADER_EXPORT___;
